import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'

type GenericApplicationData = PildomModules.Generic.Data.GenericApplicationData

export class Application extends BaseModel<GenericApplicationData> {
    override endPoint: string = 'generic'
    override translationKey: string = 'generic'
    override permissionName: string = 'APP_{application_name}_application'

    override getPermissionName(): string {
        return super.getPermissionName()
            .replace('{application_name}', this.data.name)
    }
}
